import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Can from 'components/auth/Can';
import Button from 'components/base/Button';
import Icon from 'components/icon';
import React from 'react';
import { ListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import settingSiteMap from 'sitemaps/settingSiteMap';

const SettingNav = () => {
  return (
    <div>
      <div className="d-flex justify-content-center p-5">
        <div style={{ maxWidth: '400px', width: '100%' }}>
          <div className="d-flex justify-content-center align-items-center">
            <h4 className="text-900 mb-3">
              <Icon icon={'lucide:settings'} fontSize="24px" className="me-2" />
              Settings
            </h4>
          </div>
          <ListGroup className="bg-white mb-2">
            {settingSiteMap?.map((setting, i) => (
              <Can
                I={setting.actionName || 'view'}
                key={`${setting.name}-${i}`}
                this={setting.moduleName}
              >
                <ListGroup.Item action as={Link} to={setting.path}>
                  <FontAwesomeIcon
                    className="me-2 fw-light"
                    icon={setting.icon}
                    transform={{ size: 16 }}
                  />
                  {setting.name}
                </ListGroup.Item>
              </Can>
            ))}
            {/* <ListGroup.Item action href="#link2" disabled>
            Link 2
          </ListGroup.Item>
          <ListGroup.Item action onClick={() => {}}>
            This one is a button
          </ListGroup.Item>
          <ListGroup.Item action href="#link3">
            Link 3
          </ListGroup.Item>
          <ListGroup.Item action href="#link4">
            Link 4
          </ListGroup.Item> */}
          </ListGroup>
          <div className="d-flex justify-content-between align-items-center">
            <Button
              variant="link"
              as={Link}
              to={'/'}
              className="text-danger fw-medium p-2"
            >
              <Icon icon={'solar:arrow-left-linear'} fontSize="16px" />

              <span className="ms-2">Back to Home</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingNav;
